import * as React from "react";

import * as moment from "moment";

import { Button } from "@common/components/Atoms/Button";
import Loading from "@common/components/Atoms/Loading";
import Showing from "@common/components/Atoms/Showing";
import Modal from "@common/components/Molecules/Modal";
import Pagination from "@common/components/Molecules/Pagination";
import { Activity as ActivityModel } from "@common/models";
import { GlobalConfig } from "@common/utils/config";

const breakpoints = GlobalConfig.ui.breakpoints;

/*===========================================================================
  Activities List
/*======================================================================== */

interface ActivityItemProps {
    index: number
    activity: ActivityModel
};

export const ActivityItem = (props: ActivityItemProps) => {
    return (
        <div className="c-activity" key={props.index}>
            <div className="c-activity__bullet">
                <div className="c-activity__circle" />
            </div>
            <div className="c-activity__content">
                <div className="c-activity__timestamp">
                    <span>
                        {moment(props.activity.timestamp)
                            .local()
                            .format("lll")}
                    </span>
                </div>
                <div className="c-activity__description">
                    <span className="c-activity__user">{props.activity.user_name}</span>
                    {props.activity.text}
                </div>
            </div>
        </div>
    );
};

interface ActivityListProps {
    data: ActivityModel[]
    classes?: string
};

export const ActivityList = (props: ActivityListProps) => {
    return (
        <div className={props.classes}>
            {props.data &&
                props.data.map((a, i) => <ActivityItem key={`a${i}`} index={i} activity={a} />)}
        </div>
    );
};


interface ActivityFacetsProps {
    rangeStart: string
    rangeEnd: string
    onRangeChange: (start: string, end: string) => void
};


export class ActivityFacets extends React.Component<ActivityFacetsProps> {
    constructor(props: ActivityFacetsProps) {
        super(props);

        this.state = {};
        this.changeRangeStart = this.changeRangeStart.bind(this);
        this.changeRangeEnd = this.changeRangeEnd.bind(this);
    }

    changeRangeStart(event) {
        if (this.props.onRangeChange) this.props.onRangeChange(event.target.value, this.props.rangeEnd);
    }

    changeRangeEnd(event) {
        if (this.props.onRangeChange) this.props.onRangeChange(this.props.rangeStart, event.target.value);
    }

    render() {
        return (
            <div className="c-facets__group">
                <div className="c-facets__group-title">range</div>
                <div className="c-facets__options">
                    <div className="c-facets__option">
                        <div className="c-control c-control--date">
                            <div className="c-control__label">
                                <label>start</label>
                            </div>
                            <div className="c-control__wrapper">
                                <input
                                    className="c-control__input"
                                    type="date"
                                    value={this.props.rangeStart}
                                    onChange={this.changeRangeStart}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="c-facets__option">
                        <div className="c-control c-control--date">
                            <div className="c-control__label">
                                <label>end</label>
                            </div>
                            <div className="c-control__wrapper">
                                <input
                                    className="c-control__input"
                                    type="date"
                                    value={this.props.rangeEnd}
                                    onChange={this.changeRangeEnd}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

interface ActivityFacetsModalProps {
    rangeStart: string
    rangeEnd: string
    onRangeChange: (start: string, end: string) => void
    closeModal: (modalName: string) => void
    filtersModalIsOpen: boolean
}

interface ActivityFacetsModalState {
    rangeStart: string
    rangeEnd: string
}

class ActivityFacetsModal extends React.Component<ActivityFacetsModalProps, ActivityFacetsModalState> {
    constructor(props: ActivityFacetsModalProps) {
        super(props);

        this.state = {
            rangeStart: this.props.rangeStart,
            rangeEnd: this.props.rangeEnd
        };

        this.onModalRangeChange = this.onModalRangeChange.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);
    }

    onModalRangeChange(rangeStart, rangeEnd) {
        this.setState({ rangeStart, rangeEnd });
    }

    onCloseModal() {
        this.props.onRangeChange(this.state.rangeStart, this.state.rangeEnd);
        this.props.closeModal("filtersModalIsOpen");
    }

    render() {
        return (
            <Modal
                className="c-modal--filters"
                size="full"
                isOpen={this.props.filtersModalIsOpen}
                closeModal={this.onCloseModal} >
                <div className="c-modal__filters">
                    <div className="c-modal__filters-title">filters</div>

                    <div className="c-facets c-facets--overlay">
                        <ActivityFacets
                            rangeStart={this.state.rangeStart}
                            rangeEnd={this.state.rangeEnd}
                            onRangeChange={this.onModalRangeChange}
                        />
                    </div>
                </div>
            </Modal>
        );
    }
}


const ActivityFacetsSideBar = (props) => (
    <section className="c-filtered-list__filters">
        <header className="c-filtered-list__header">
            <div className="c-filtered-list__header-title">refine</div>
        </header>
        <div className="c-facets">
            <ActivityFacets
                rangeStart={props.rangeStart}
                rangeEnd={props.rangeEnd}
                onRangeChange={props.onRangeChange}
            />
        </div>
    </section>
);

interface ActivitiesListProps {
    rangeStart: string
    rangeEnd: string
    data?:{
        results: ActivityModel[]
        current_page:number
        page_size:number
        total:number
    }
    onPageChange: (page: number) => void
    onRangeChange: (start:any, end:any) => void
    openModal: (modalName: string) => void
    closeModal: (modalName:string) => void
    isLoading: boolean
    filtersModalIsOpen: boolean
}

interface ActivitiesListState {
    isLargeScreen: boolean
}

class ActivitiesList extends React.Component<ActivitiesListProps, ActivitiesListState> {
    constructor(props: ActivitiesListProps) {
        super(props);

        this.state = {
            isLargeScreen: false
        };

        this.GetHeader = this.GetHeader.bind(this);
    }

    componentDidMount() {
        this.setState({
            isLargeScreen: window.matchMedia(`(min-width:${breakpoints.md}px)`).matches
        });
        window.onresize = () => {
            this.setState({
                isLargeScreen: window.matchMedia(`(min-width:${breakpoints.md}px)`)
                    .matches
            });
        };
    }

    GetHeader() {
        return (
            <header className="c-filtered-list__header">
                <div className="c-filtered-list__header-title">
                    <Showing
                        currentPage={!!this.props.data ? this.props.data.current_page : 0}
                        pageSize={!!this.props.data ? this.props.data.page_size : 0}
                        total={!!this.props.data ? this.props.data.total : 0}
                    />
                </div>
                {!this.state.isLargeScreen && (
                    <div className="c-filtered-list__header-actions">
                        <Button
                            id="openFiltersModalButton"
                            onClick={() => this.props.openModal("filtersModalIsOpen")}>
                            filters
                        </Button>
                    </div>
                )}
            </header>
        );
    }
   render() {
        const { isLargeScreen } = this.state;
        const { data, isLoading } = this.props;

        if(!data) return null;

        const hasResults = data && data.results && data.results.length > 0;
        
        const actvitiesHtml = hasResults ? (
            <React.Fragment>
                <ActivityList data={data.results} />
                <Pagination
                    currentPage={data.current_page}
                    pageSize={data.page_size}
                    total={data.total}
                    onPageChange={page => this.props.onPageChange(page.selected + 1)}
                />
            </React.Fragment>
        ) : (
            <React.Fragment>
                <br />
                <h2 className="c-heading c-heading--purple">
                    we didn't find any activities matching your search.
                </h2>
                <h2 className="c-heading c-heading--purple">try expanding your range.</h2>
            </React.Fragment>
        );

        return (
            <div>
                <section
                    className={
                        "c-filtered-list__view c-filtered-list__view" +
                        (isLargeScreen ? "--table" : "--cards")
                    }>

                    {isLargeScreen
                        ? <ActivityFacetsSideBar {...this.props} />
                        : <ActivityFacetsModal {...this.props} />}

                    <section className="c-filtered-list__table">
                        {this.GetHeader()}
                        {isLoading && <Loading />}
                        {actvitiesHtml}
                    </section>
                </section>
            </div>
        );
    }
}

export default ActivitiesList;
